/* AllySabers R8.7-R8.8: light enhancements on top of R8.6, loaded last.
   1. (R8.8) Delivery estimates are back to R8's 8-12 business days: orders usually arrive early, so the earlier date
      is the honest one.
   2. Saber Finder: the "original design" answer no longer claims the hilts can't be found anywhere else.
   3. Core lab: a visible way into the Ignite demo and the bolts game ("Try the cores live").
   4. Product pages on phones: the review feed is capped at about one screen, with "Show all reviews".
   5. Homepage: the Replicas rail skips sabers already shown in Best sellers.
   6. Footer on phones: the Shop and Help link lists fold into tap-to-open rows. */
(() => {
  const phone = window.matchMedia('(max-width: 699px)');

  /* ------------------------------------------------------------ */
  /* 2. Finder wording                                             */
  /* ------------------------------------------------------------ */

  const finderCopy = () => {
    document.querySelectorAll('.ig-finder__opt[data-value="original"] small:not([data-r87])').forEach(el => {
      el.dataset.r87 = '1';
      el.textContent = 'Not based on a film character.';
    });
  };

  // the picks now sit right under the core on phones and beside it on desktop, so the reason no longer says "Below"
  document.addEventListener('finder:result', e => {
    const finder = e.target.closest && e.target.closest('ig-finder');
    const why = finder && finder.querySelector('[data-finder-why]');
    if (why) why.textContent = why.textContent.replace(/ Below: three /, ' Your top 3 are ');
  });

  /* ------------------------------------------------------------ */
  /* 3. Core lab: try the cores live                               */
  /* ------------------------------------------------------------ */

  const tryLive = () => {
    document.querySelectorAll('ig-cores:not([data-r87])').forEach(lab => {
      const demoTab = lab.querySelector('.ig-cores__view[data-view="demo"]');
      const lede = lab.querySelector('.ig-lede');
      lab.dataset.r87 = '1';
      if (!demoTab || !lede) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'r87-try';
      btn.innerHTML = '<span class="r87-try__label">Try the cores live</span><span class="r87-try__text">Ignite each one, then play Deflect the bolts.</span>';
      btn.addEventListener('click', () => {
        demoTab.click();
        const panel = document.getElementById(demoTab.getAttribute('aria-controls')) || demoTab;
        const tabs = demoTab.parentElement || panel;
        requestAnimationFrame(() => tabs.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      });
      lede.insertAdjacentElement('afterend', btn);
    });
  };

  /* ------------------------------------------------------------ */
  /* 4. Review feed cap on phones                                  */
  /* ------------------------------------------------------------ */

  const reviewCap = () => {
    if (!document.body.classList.contains('page-type-product')) return;
    const frame = document.querySelector('iframe[src*="loox.io/widget"]');
    const section = frame && frame.closest('.shopify-section');
    if (!section || section.dataset.r87) return;
    section.dataset.r87 = '1';
    section.classList.add('r87-reviews');
    const more = document.createElement('div');
    more.className = 'r87-reviews__more';
    more.innerHTML = '<button type="button" class="ig-btn ig-btn--ghost">Show all reviews</button>';
    more.querySelector('button').addEventListener('click', () => {
      section.classList.add('is-open');
      more.remove();
    });
    section.appendChild(more);
  };

  /* ------------------------------------------------------------ */
  /* 5. Homepage rails without repeats                             */
  /* ------------------------------------------------------------ */

  const dedupe = () => {
    const best = document.querySelector('[id$="__ig_best"]');
    const rail = document.querySelector('[id$="__ig_replicas"] .ig-products');
    if (!best || !rail || rail.dataset.r87) return;
    rail.dataset.r87 = '1';
    const key = a => (a.getAttribute('href') || '').split('?')[0];
    const shown = new Set([...best.querySelectorAll('a.ig-card')].map(key));
    const items = [...rail.children];
    const repeats = items.filter(item => {
      const a = item.querySelector('a.ig-card');
      return a && shown.has(key(a));
    });
    // keep at least four in the rail
    if (items.length - repeats.length >= 4) repeats.forEach(item => item.remove());
  };

  /* ------------------------------------------------------------ */
  /* 6. Footer link lists on phones                                */
  /* ------------------------------------------------------------ */

  const footer = () => {
    document.querySelectorAll('.ig-footer__col:not([data-r87])').forEach((col, i) => {
      const label = col.querySelector('.ig-footer__label');
      const list = col.querySelector('ul');
      col.dataset.r87 = '1';
      if (!label || !list) return;
      const id = `r87-footer-list-${i}`;
      list.id = list.id || id;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'r87-fold';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', list.id);
      btn.textContent = label.textContent.trim();
      btn.addEventListener('click', () => {
        const open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
      label.insertAdjacentElement('afterend', btn);
      col.classList.add('r87-foldable');
    });
  };

  /* ------------------------------------------------------------ */
  /* 7. (R8.8) Mobile menu tiles get a colored label, like the     */
  /*    homepage path cards. The colors live in ally-r87.css.      */
  /* ------------------------------------------------------------ */

  const NAV_LABELS = [
    ['/collections/front', 'Most chosen'],
    ['/collections/new-arrivals', 'Just landed'],
    ['/collections/replicas', 'Collector focused'],
    ['/pages/eco-sabers', 'Accessible entry'],
    ['/collections/combo-packs', 'Pairs & staffs'],
    ['/collections/accessories', 'Stands & cases']
  ];

  const navLabels = () => {
    document.querySelectorAll('.ally-mobile-nav__grid a:not([data-r88-label])').forEach(a => {
      const href = a.getAttribute('href') || '';
      const hit = NAV_LABELS.find(([path]) => href.indexOf(path) > -1);
      if (hit) a.dataset.r88Label = hit[1];
    });
  };

  /* ------------------------------------------------------------ */

  const run = () => {
    navLabels();
    finderCopy();
    tryLive();
    reviewCap();
    dedupe();
    footer();
  };

  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      finderCopy();
      reviewCap();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // the quiz sheet adds finder answers later, and the review app adds its frame after the page loads
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', run);
  if (phone.addEventListener) phone.addEventListener('change', run);
})();
